import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "SetTimeZoneLocal" })

export class SetTimeZoneTransformPipe implements PipeTransform {
  transform(value: string) {
    let setDateTime = new Date();
    if (value) {
        if (value.indexOf("-") > -1) {
        const removedCharacterFromDateTime = value.replace("T", " ").replace("Z", "");
        const callRecordDateTime = new Date(removedCharacterFromDateTime);
        setDateTime = new Date(callRecordDateTime.setMinutes(callRecordDateTime.getMinutes() - (new Date().getTimezoneOffset())));
      } else {
        const offSet = new Date().getTimezoneOffset();
        const dateTime = new Date(value);
        const timeStamp = dateTime.setMinutes(dateTime.getMinutes() - (offSet));
        setDateTime = new Date(timeStamp);
      }
    }

    return setDateTime;
  }
}
